import {SET_ACCOUNT, setAccountT} from "../reducers/AccountState";


export const SetAccount = (data: setAccountT['data']) => {
    return({
        type: SET_ACCOUNT,
        data: data
    })
}
